import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './Tabs.module.scss'

const baseRadix = 36

export interface TabsProps extends BaseComponentProps {
  customTabGroupID?: string | null
}

export class Tabs extends React.Component<TabsProps> {
  static defaultProps = {}

  groupID: string;

  constructor(props: TabsProps) {
    super(props)
    this.groupID = this.props.customTabGroupID
      || `tabGroup-${Math.random().toString(baseRadix).slice(2)}`
  }

  // Add displayName to preserve the component name on snapshot testing
  displayName = 'Tabs'

  render() {
    return (
      <div className={extractClassNamesFromProps(this.props, st.group, 'dvui-tabs')}>
        {React.Children.map(this.props.children, (child, index) => (
          (typeof child === 'number' || typeof child === 'string') ? null :
          React.cloneElement(child, {
            groupID: this.groupID,
            isSelected: (index < 1)
          })
        ))}
      </div>
    )
  }
}


export interface TabSectionProps {
  customTabSectionID?: string | null
  groupID?: string
  name: string
  isSelected?: boolean
}


export class TabSection extends React.Component<TabSectionProps> {
  static defaultProps = {
    isSelected: false,
    groupID: 'noGroupIDSet'
  }

  sectionID: string;

  constructor(props: TabSectionProps) {
    super(props)
    this.sectionID = this.props.customTabSectionID
      || `tabSection-${Math.random().toString(baseRadix).slice(2)}`
  }

  // Add displayName to preserve the component name on snapshot testing
  displayName = 'TabSection'

  render() {
    return (
      <>
        <input
          id={this.sectionID}
          name={this.props.groupID}
          className={st.hiddenTabSelector}
          defaultChecked={this.props.isSelected}
          type="radio" />
        <section>
          <h2 className={st.heading}>
            <label htmlFor={this.sectionID}>{this.props.name}</label>
          </h2>
          <article className={extractClassNamesFromProps(this.props, st.content)}>
            {this.props.children}
          </article>
        </section>
      </>
    )
  }
}
